import React from 'react';
import { useFadeInOnScroll } from '../hooks/useFadeInOnScroll';

export function ExploreCta() {
  const { ref, style } = useFadeInOnScroll<HTMLElement>();

  return (
    <section
      ref={ref}
      className="explore-cta"
      aria-labelledby="explore-cta-title"
      style={style}
    >
      <h2 id="explore-cta-title" className="explore-cta__title">
        Explore Bilateral Editions
      </h2>
      <p className="explore-cta__subtitle">
        Search diplomatic profiles across 193 countries and 18,528 bilateral
        relationships
      </p>
      <a href="https://bilateralnavigator.com/search" className="explore-cta__button">
        Start Exploring
      </a>
    </section>
  );
}
